"use client";

import { c as _c } from "react/compiler-runtime";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { ResponsiveAd } from "@components/ads";
import { useFilterContext } from "@components/filter/filter-context";
import type { MemberListEntry } from "@lib/api/member/types";
import type { MemberParty } from "@lib/api/parliament/types";
import MemberCard from "./member-card";
interface Props {
  members: MemberListEntry[];
}
const MEMBERS_STEP = 18;
export default function MemberList(t0) {
  const $ = _c(22);
  const {
    members
  } = t0;
  const endRef = useRef(null);
  const [amount, setAmount] = useState(MEMBERS_STEP);
  const {
    search,
    activeToggles
  } = useFilterContext();
  let t1;
  if ($[0] !== activeToggles || $[1] !== members) {
    t1 = activeToggles.length ? members.filter(member => activeToggles.includes(member.party)) : members;
    $[0] = activeToggles;
    $[1] = members;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const inParty = t1;
  let t2;
  if ($[3] !== inParty || $[4] !== members || $[5] !== search) {
    t2 = search ? members.filter(member_0 => `${member_0.firstName} ${member_0.lastName}`.toLocaleLowerCase().includes(search.toLocaleLowerCase())) : inParty;
    $[3] = inParty;
    $[4] = members;
    $[5] = search;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const inSearch = t2;
  const filteredMembers = inSearch;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setAmount(MEMBERS_STEP);
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== activeToggles || $[9] !== members || $[10] !== search) {
    t4 = [search, activeToggles, members];
    $[8] = activeToggles;
    $[9] = members;
    $[10] = search;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  if ($[12] !== filteredMembers.length) {
    t5 = () => {
      if (!endRef.current) {
        return;
      }
      const observer = new IntersectionObserver(t6 => {
        const [endElement] = t6;
        if (endElement.isIntersecting) {
          setAmount(prevValue => prevValue < filteredMembers.length ? prevValue + MEMBERS_STEP : prevValue);
        }
      }, {
        rootMargin: "40px 0px 0px 0px"
      });
      observer.observe(endRef.current);
      return () => {
        observer.disconnect();
      };
    };
    $[12] = filteredMembers.length;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== filteredMembers) {
    t6 = [filteredMembers];
    $[14] = filteredMembers;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  useEffect(t5, t6);
  let t7;
  if ($[16] !== amount || $[17] !== filteredMembers) {
    t7 = filteredMembers.slice(0, amount).map(_temp);
    $[16] = amount;
    $[17] = filteredMembers;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div ref={endRef} />;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7) {
    t9 = <div className="grid flex-1 grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">{t7}{t8}</div>;
    $[20] = t7;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp(member_1, index) {
  return <Fragment key={member_1.id}>{index % 12 === 0 && <div className="lg:col-span-2 xl:col-span-3"><ResponsiveAd /></div>}<MemberCard member={member_1} /></Fragment>;
}